import script from "./Notice.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notice.vue?vue&type=script&setup=true&lang=ts"

import "./Notice.vue?vue&type=style&index=0&id=4c010fb5&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c010fb5"]])

export default __exports__